import { ReleaseNote } from "src/app/interfaces/modal.interface";

export const directory: ReleaseNote[] = [
	{
		"releaseTitle": "ORC 2021.04.1",
		"fileName": "release-notes-2021-04.html"
	},
	{
		"releaseTitle": "ORC 2021.05.1",
		"fileName": "release-notes-2021-05.html"
	},
	{
		"releaseTitle": "ORC 2021.06.1",
		"fileName": "release-notes-2021-06.html"
	},
	{
		"releaseTitle": "ORC 2021.07.1",
		"fileName": "release-notes-2021-07.html"
	},
	{
		"releaseTitle": "ORC 2021.08.1",
		"fileName": "release-notes-2021-08.html"
	},
	{
		"releaseTitle": "ORC 2021.09.1",
		"fileName": "release-notes-2021-09.html"
	},
	{
		"releaseTitle": "ORC 2021.09.2",
		"fileName": "release-notes-2021-09-2.html"
	},
	{
		"releaseTitle": "ORC 2021.10.1",
		"fileName": "release-notes-2021-10.html"
	},
	{
		"releaseTitle": "ORC 2021.11.1",
		"fileName": "release-notes-2021-11.html"
	},
	{
		"releaseTitle": "ORC 2021.12.1",
		"fileName": "release-notes-2021-12.html"
	},
	{
		"releaseTitle": "ORC 2022.01.1",
		"fileName": "release-notes-2022-01.html"
	},
	{
		"releaseTitle": "ORC 2022.02.1",
		"fileName": "release-notes-2022-02.html"
	},
	{
		"releaseTitle": "ORC 2022.03.1",
		"fileName": "release-notes-2022-03.html"
	},
	{
		"releaseTitle": "ORC 2022.04.1",
		"fileName": "release-notes-2022-04.html"
	},
	{
		"releaseTitle": "ORC 2022.05.1",
		"fileName": "release-notes-2022-05.html"
	},
	{
		"releaseTitle": "ORC 2022.06.1",
		"fileName": "release-notes-2022-06.html"
	},
	{
		"releaseTitle": "ORC 2022.07.1",
		"fileName": "release-notes-2022-07.html"
	},
	{
		"releaseTitle": "ORC 2022.08.1",
		"fileName": "release-notes-2022-08.html"
	},
	{
		"releaseTitle": "ORC 2022.09.1",
		"fileName": "release-notes-2022-09.html"
	},
	{
		"releaseTitle": "ORC 2022.10.1",
		"fileName": "release-notes-2022-10.html"
	},
	{
		"releaseTitle": "ORC 2022.11.1",
		"fileName": "release-notes-2022-11.html"
	},
	{
		"releaseTitle": "ORC 2023.01.1",
		"fileName": "release-notes-2023-01.html"
	},
	{
		"releaseTitle": "ORC 2023.02.1",
		"fileName": "release-notes-2023-02.html"
	},
	{
		"releaseTitle": "ORC 2023.03.1",
		"fileName": "release-notes-2023-03.html"
	},
	{
		"releaseTitle": "ORC 2023.04.1",
		"fileName": "release-notes-2023-04.html"
	},
	{
		"releaseTitle": "ORC 2023.05.1",
		"fileName": "release-notes-2023-05.html"
	},
	{
		"releaseTitle": "ORC 2023.06.1",
		"fileName": "release-notes-2023-06.html"
	},
	{
		"releaseTitle": "ORC 2023.07.1",
		"fileName": "release-notes-2023-07.html"
	},
	{
		"releaseTitle": "ORC 2023.08.1",
		"fileName": "release-notes-2023-08.html"
	},
	{
		"releaseTitle": "ORC 2023.09.1",
		"fileName": "release-notes-2023-09.html"
	},
	{
		"releaseTitle": "ORC 2023.10.1",
		"fileName": "release-notes-2023-10.html"
	},
	{
		"releaseTitle": "ORC 2024.01.1",
		"fileName": "release-notes-2024-01.html"
	},
	{
		"releaseTitle": "ORC 2024.02.1",
		"fileName": "release-notes-2024-02.html"
	},
	{
		"releaseTitle": "ORC 2024.04.1",
		"fileName": "release-notes-2024-04.html"
	},
	{
		"releaseTitle": "ORC 2024.06.1",
		"fileName": "release-notes-2024-06.html"
	},
	{
		"releaseTitle": "ORC 2024.09.1",
		"fileName": "release-notes-2024-09.html"
	},
	{
		"releaseTitle": "ORC 2024.10.1",
		"fileName": "release-notes-2024-10.html"
	},
	{
		"releaseTitle": "ORC 2025.01.1",
		"fileName": "release-notes-2025-01-01.html"
	},
	{
		"releaseTitle": "ORC 2025.01.2",
		"fileName": "release-notes-2025-01-02.html"
	},
]

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
